import Vue from 'vue'
import dateFilter from './date.filter'


Vue.filter('date', dateFilter)